import { useLanguage } from "@/context/LanguageContext";
import { Reveal, SectionHead } from "@/components/Reveal";

export const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" data-testid="contact-section" className="py-24 lg:py-36 bg-coal/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="max-w-4xl">
          <SectionHead label={t.contact.label} title={t.contact.title} sub={t.contact.sub} testId="contact-title" />
          <Reveal delay={0.15} className="mt-10">
            <p className="font-serif italic text-2xl text-champagne/80 leading-relaxed">
              „La musica è la lingua dell'anima."
            </p>
          </Reveal>

          <div className="mt-14 grid sm:grid-cols-2 gap-px bg-ivory/10 border border-ivory/10 max-w-4xl">
            <Reveal delay={0.1} className="h-full">
              <div data-testid="contact-management" className="h-full bg-ink p-7">
                <p className="gc-eyebrow !text-[9px]">Management · Booking · Promotion & Press</p>
                <p className="mt-5 font-serif text-lg text-ivory">Giovanni Costello Management</p>
                <p className="mt-3 text-sm text-ash font-light leading-relaxed">
                  Flurstrasse 57<br />
                  40235 Düsseldorf · Germany<br />
                  Tel. <a href="tel:+49211635561690" className="hover:text-gold transition-colors">+49 211 635561690</a>
                </p>
                <p className="mt-3 text-sm text-ash font-light leading-relaxed">
                  Lidia Di Raimondo<br />
                  <a data-testid="contact-email-lidia" href="mailto:l.diraimondo@giovannicostello.com" className="text-champagne hover:text-gold transition-colors">l.diraimondo@giovannicostello.com</a><br />
                  <a data-testid="contact-email-info" href="mailto:info@giovannicostello.com" className="text-champagne hover:text-gold transition-colors">info@giovannicostello.com</a>
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.2} className="h-full">
              <div data-testid="contact-label" className="h-full bg-ink p-7">
                <p className="gc-eyebrow !text-[9px]">Label</p>
                <p className="mt-5 font-serif text-lg text-ivory">GLM Music</p>
                <p className="mt-3 text-sm text-ash font-light leading-relaxed">
                  Angerstrasse 2D<br />
                  83730 Fischbachau<br />
                  Tel. <a href="tel:+498921538420" className="hover:text-gold transition-colors">+49 8921538420</a><br />
                  <a href="mailto:info@glm.de" className="text-champagne hover:text-gold transition-colors">info@glm.de</a> ·{" "}
                  <a data-testid="contact-glm" href="https://www.glm.de" target="_blank" rel="noopener noreferrer" className="text-champagne hover:text-gold transition-colors">www.glm.de</a>
                </p>
                <p className="mt-4 text-sm text-ash font-light leading-relaxed">
                  Edel Music & Entertainment GmbH<br />
                  <a data-testid="contact-edel" href="https://www.edel.com" target="_blank" rel="noopener noreferrer" className="text-champagne hover:text-gold transition-colors">www.edel.com</a>
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
